import { css } from 'styled-components';

export const flag = css`
  aspect-ratio: 1.49;
`;
